/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-10 11:22:59
 *
 *******************************************************/
// @flow

export const GET_QUICK_START_GUIDES_REQUEST = 'GET_QUICK_START_GUIDES_REQUEST';
type GET_QUICK_START_GUIDES_REQUEST_TYPE = 'GET_QUICK_START_GUIDES_REQUEST';

export const GET_QUICK_START_GUIDES_SUCCESS = 'GET_QUICK_START_GUIDES_SUCCESS';
type GET_QUICK_START_GUIDES_SUCCESS_TYPE = 'GET_QUICK_START_GUIDES_SUCCESS';

export const GET_QUICK_START_GUIDES_FAILURE = 'GET_QUICK_START_GUIDES_FAILURE';
type GET_QUICK_START_GUIDES_FAILURE_TYPE = 'GET_QUICK_START_GUIDES_FAILURE';

export const MARK_DONE_STEP_REQUEST = 'MARK_DONE_STEP_REQUEST';
type MARK_DONE_STEP_REQUEST_TYPE = 'MARK_DONE_STEP_REQUEST';

export const MARK_DONE_STEP_SUCCESS = 'MARK_DONE_STEP_SUCCESS';
type MARK_DONE_STEP_SUCCESS_TYPE = 'MARK_DONE_STEP_SUCCESS';

export const MARK_DONE_STEP_FAILURE = 'MARK_DONE_STEP_FAILURE';
type MARK_DONE_STEP_FAILURE_TYPE = 'MARK_DONE_STEP_FAILURE';

export const GUIDE_SEND_FEEDBACK_REQUEST = 'GUIDE_SEND_FEEDBACK_REQUEST';
type GUIDE_SEND_FEEDBACK_REQUEST_TYPE = 'GUIDE_SEND_FEEDBACK_REQUEST';

export const GUIDE_SEND_FEEDBACK_SUCCESS = 'GUIDE_SEND_FEEDBACK_SUCCESS';
type GUIDE_SEND_FEEDBACK_SUCCESS_TYPE = 'GUIDE_SEND_FEEDBACK_SUCCESS';

export const GUIDE_SEND_FEEDBACK_FAILURE = 'GUIDE_SEND_FEEDBACK_FAILURE';
type GUIDE_SEND_FEEDBACK_FAILURE_TYPE = 'GUIDE_SEND_FEEDBACK_FAILURE';

type QuickStartGuidesSuccess = {
  data: Object
};

type QuickStartGuidesFailure = {
  error: any
};

type GetQuickStartGuidesRequestAction = Action<GET_QUICK_START_GUIDES_REQUEST_TYPE, null>;

type GetQuickStartGuidesSuccessAction = Action<
  GET_QUICK_START_GUIDES_SUCCESS_TYPE,
  QuickStartGuidesSuccess
>;

type GetQuickStartGuidesFailureAction = Action<
  GET_QUICK_START_GUIDES_FAILURE_TYPE,
  QuickStartGuidesFailure
>;

type MarkDoneStepRequestAction = Action<MARK_DONE_STEP_REQUEST_TYPE, null>;

type MarkDoneStepSuccessAction = Action<MARK_DONE_STEP_SUCCESS_TYPE, QuickStartGuidesSuccess>;

type MarkDoneStepFailureAction = Action<MARK_DONE_STEP_FAILURE_TYPE, QuickStartGuidesFailure>;

type SendFeedBackGuideRequestAction = Action<GUIDE_SEND_FEEDBACK_REQUEST_TYPE, null>;
type SendFeedBackGuideSuccessAction = Action<
  GUIDE_SEND_FEEDBACK_SUCCESS_TYPE,
  QuickStartGuidesSuccess
>;
type SendFeedBackGuideFailureAction = Action<
  GUIDE_SEND_FEEDBACK_FAILURE_TYPE,
  QuickStartGuidesFailure
>;

type QuickStartGuideType = {
  id: number,
  tenantId: string,
  name: string,
  optEmail: string,
  isDone: boolean,
  order: number,
  createdAt: number,
  updatedAt: number
};

export type QuickStartGuidesState = {
  loading: boolean,
  success: boolean,
  error: any,
  data: Array<QuickStartGuideType>
};

export type QuickStartGuidesAction =
  | GetQuickStartGuidesRequestAction
  | GetQuickStartGuidesSuccessAction
  | GetQuickStartGuidesFailureAction
  | MarkDoneStepRequestAction
  | MarkDoneStepSuccessAction
  | MarkDoneStepFailureAction
  | SendFeedBackGuideRequestAction
  | SendFeedBackGuideSuccessAction
  | SendFeedBackGuideFailureAction;
